import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

import { LetDirective } from '@ngrx/component';

import { Account } from '@personal-area/global/accounts/models';
import { TogglerModule } from '@personal-area/global/ui';

import { SwapFreeComponentStore } from './account-viewer-swap-free.component.store';

@Component({
    selector: 'global-account-viewer-swap-free',
    templateUrl: './account-viewer-swap-free.component.html',
    styleUrls: ['./account-viewer-swap-free.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, TogglerModule, LetDirective],
    providers: [SwapFreeComponentStore]
})
export class AccountViewerSwapFreeComponent implements OnChanges {
  @Input() account!: Account;

  public isChecked$ = this._componentStore.isChecked;
  public isLoading$ = this._componentStore.isLoading;
  public isDisabled$ = this._componentStore.isDisabled;

  constructor(private _componentStore: SwapFreeComponentStore) {}

  public ngOnChanges(changes: SimpleChanges): void {
    this._componentStore.setup(this.account);
  }

  public toggleSwapFree(): void {
    this._componentStore.toggle(this.account);
  }
}
